import React, { useState } from 'react';
import { FormattedMessage } from "react-intl";

import Config from "../../../../../../config";

const SqftFatalErrorTestButton = () => {
  const [shouldCrashApp, setShouldCrashApp] = useState(false);
  const canShowFatalErrorTestButton = Config.isDevMode() || Config.isDemo() || document.kvConfig.demoMode;

  if (shouldCrashApp) {
    throw new Error('SQFT demo fatal error test');
  }

  return canShowFatalErrorTestButton ? (
    <button className="btn ui-button2 ui-button2--red" onClick={() => setShouldCrashApp(true)}>
      <FormattedMessage id="sqft.footer.fatalErrorTestButton" />
    </button>
  ) : null;
};

export default SqftFatalErrorTestButton;
